import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import {
  EVENT_CLICK_APPLYOFFERFAILURE,
  EVENT_CLICK_APPLYMANUALCOUPONFAILURE,
  EVENT_OFFER_SCREEN,
} from "../../helpers/analyticsEvents";
import Utility from "../../helpers/utility";
import {
  keyMapsMutation,
  keyMapsAction,
  keyMapsGetter,
} from "../../helpers/storeKeys";

export default {
  namespaced: true,
  state: {
    offersList: [],
    welcomeOffers: [],
    selectedOfferIndex: LocalStorageFunc.getSelectedOfferIndex() || -1,
    selectedOfferTnc: [],
    offerApplyResponse: {},
    isOpenOfferAppliedModal: false,
    offerDetailsModalFlag: false,
    offerFailedMsg: "",
    topCouponIndex: -1,
    isViewAllOffersSelected: false,
    isOfferAppliedModal:
      JSON.parse(LocalStorageFunc.getOfferAppliedModal()) || false,
    selectedOffer: {},
    isCartSelected: false,
    appliedOfferPromo: LocalStorageFunc.getCouponCode()?.code || "",
    discount: "",
    manualOffer: "",
    failedOfferPromo: "",
    initOfferListingWrapper: false,
    offerDetailsFromBottomBar: false,
    showOfferToastMsg: false,
    cartOfferShimmer: false,
    bestOffer: {},
    cartOffers: [],
    selectedOfferTheme: LocalStorageFunc.getOfferTheme() || "",
    desktopTncShimmer: false,
  },
  getters: {},
  mutations: {
    updateOffersList(state, payload) {
      state.offersList = payload;
    },
    updateDesktopTncShimmer(state, payload) {
      state.desktopTncShimmer = payload;
    },
    updateWelcomeOffer(state, payload) {
      state.welcomeOffers = payload;
    },
    updateFailedOfferPromo(state, payload) {
      state.failedOfferPromo = payload;
    },
    updateAppliedOfferPromo(state, payload) {
      LocalStorageFunc.updateCouponCode(payload);
      state.appliedOfferPromo = payload;
    },
    updateBestOffer(state, payload) {
      state.bestOffer = payload;
    },
    updateCartOffers(state, payload) {
      state.cartOffers = payload;
    },
    updateDiscount(state, payload) {
      state.discount = payload;
    },
    updateOfferApplyResponse(state, payload) {
      state.offerApplyResponse = payload;
    },
    updateManualOffer(state, payload) {
      state.manualOffer = payload;
    },
    updateSelectedOfferIndex(state, payload) {
      state.selectedOfferIndex = payload;
      LocalStorageFunc.setSelectedOfferIndex(payload);
    },
    updateSelectedOfferTnc(state, payload) {
      state.selectedOfferTnc = payload;
    },
    updateOfferApplyModalKey(state, payload) {
      state.isOpenOfferAppliedModal = payload;
    },
    updateOfferFailedMsg(state, payload) {
      state.offerFailedMsg = payload;
    },
    updateOfferDetailsFromBottomBar(state, payload) {
      state.offerDetailsFromBottomBar = payload;
    },
    updateOfferDetailsModalFlag(state, payload) {
      state.offerDetailsModalFlag = payload;
    },
    updateTopCoupon(state, payload) {
      state.topCouponIndex = payload;
    },
    updateViewAllOffers(state, payload) {
      state.isViewAllOffersSelected = payload;
    },
    updateOfferAppliedModal(state, payload) {
      state.isOfferAppliedModal = payload;
    },
    updateSelectedOffer(state, payload) {
      state.selectedOffer = payload;
    },
    updateIsCartSelected(state, payload) {
      state.isCartSelected = payload;
    },
    updateInitOfferListingWrapper(state, payload) {
      state.initOfferListingWrapper = payload;
    },
    updateShowOfferFailedMsg(state, payload) {
      state.showOfferToastMsg = payload;
    },
    updateSelectedOfferTheme(state, payload) {
      LocalStorageFunc.setOfferTheme(payload);
      state.selectedOfferTheme = payload;
    },
  },
  actions: {
    welcomeOfferApi({ commit, state, rootState }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      ApiCalls.STORE_OFFERS_API({
        headers: { ...Headers() },
        payload: payload,
      })
        .then(function (response) {
          if (response?.data?.coupons?.length) {
            // let welcomeOffers = response?.data?.data?.sort(
            //   (a, b) => b.metaData.priority - a.metaData.priority
            // );
            commit("updateWelcomeOffer", response?.data?.coupons);
            commit(
              "updateOffersList",
              response?.data?.coupons.flatMap((category) => category?.data)
            );
            // let maxMOV = Math.max(
            //   ...response.data.applicable.data.map((offer) =>
            //     offer.couponDetail.minCartValue
            //       ? offer.couponDetail.minCartValue
            //       : 0
            //   )
            // );
            // const index = response.data.applicable.data
            //   .map((i) => i.couponDetail.minCartValue)
            //   .indexOf(maxMOV);
            // commit("updateTopCoupon", 0);
            if (response?.data?.coupons?.length) {
              if (LocalStorageFunc.getCouponCode()?.code !== undefined) {
                let currentCoupneCodeIndex = response?.data?.data?.findIndex(
                  (i) => i.couponCode == LocalStorageFunc.getCouponCode().code
                );
                commit("updateSelectedOfferIndex", currentCoupneCodeIndex);
              }
              commit("updateOfferApplyModalKey", true);
              commit("updateOfferApplyResponse", { status: "SUCCESS" });
              LocalStorageFunc.setGetOfferSuccess("SUCCESS");
            }
          }
          // else if (response?.data?.milestoneOffers?.data) {
          //   commit(
          //     "updateWelcomeOffer",
          //     ...response.data.milestoneOffers.data.map((milestoneOffer) => {
          //       return { ...milestoneOffer, type: "MILESTONE" };
          //     })
          //   );
          // }
          else {
            // @Todo : uncomment below line and comment other line putting fallback data
            // commit("updateWelcomeOffer", OffersData);
            // let maxMOV = Math.max(
            //   ...OffersData.map((offer) =>
            //     offer.couponDetail.minCartValue
            //       ? offer.couponDetail.minCartValue
            //       : 0
            //   )
            // );
            // const index = OffersData.map(
            //   (i) => i.couponDetail.minCartValue
            // ).indexOf(maxMOV);

            // commit("updateTopCoupon", index);
            // console.log("No offers available");
            commit("updateWelcomeOffer", {});
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
          if (!rootState.ProductItems.showSearchModal) {
            document.body.classList.remove("body-stop-scroll-mobile");
          }
        })
        .catch(function (error) {
          commit("updateWelcomeOffer", {});
          commit("updateOfferApplyResponse", { status: "" });
          LocalStorageFunc.setGetOfferSuccess("");

          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
          if (!rootState.ProductItems.showSearchModal) {
            document.body.classList.remove("body-stop-scroll-mobile");
          }
        });
    },
    applyOfferApi({ commit, dispatch, rootState, rootGetters }, payload) {
      ApiCalls.APPLY_WELCOME_OFFER_API({
        headers: { ...Headers() },
        payload: {
          promos: [{ code: payload.couponCode }],
        },
      })
        .then(function (response) {
          commit("updateOfferApplyResponse", response.data);
          let errMsg = "";
          if (response.data.status == "SUCCESS") {
            commit(
              "updateDiscount",
              response.data.baseCalculationsMap?.discount?.roundedValue
            );

            commit("updateOfferAppliedModal", true);
            setTimeout(() => {
              commit("updateOfferAppliedModal", false);
            }, 3000);
            commit("updateViewAllOffers", false);

            errMsg =
              response?.data?.errorMessages?.[0]?.message ||
              response?.data?.discountAllocations?.[0]?.errors?.[0]
                ?.displayMessage;
            errMsg
              ? commit("updateOfferFailedMsg", errMsg)
              : commit("updateOfferFailedMsg", "");

            errMsg && commit("updateShowOfferFailedMsg", true);
            setTimeout(() => {
              commit("updateShowOfferFailedMsg", false);
            }, 5000);

            commit("updateFailedOfferPromo", payload.couponCode);
            commit("updateDiscount", "");
            if (payload.source && payload.source == "MANUAL") {
              commit("updateManualOffer", payload.couponCode);
            }

            !errMsg && commit("updateAppliedOfferPromo", payload.couponCode);
            if (
              LocalStorageFunc.getPrevUrl().includes("/cart") &&
              !Utility.isCurrentlyAtUrl("/cart") &&
              !errMsg
            ) {
              if (payload.source && payload.source == "MANUAL") {
                EVENT_OFFER_SCREEN({
                  eventAction: "coupon applied",
                  sectionName: "manual input",
                  catergory: "coupon application",
                  subcategory: "coupon application success",
                  cartId: LocalStorageFunc.cartId(),
                  failureReason: errMsg,
                  couponDetail: payload.detail,
                  paymentMethod: "",
                  taxChargesCategory: response?.data?.calculations
                    ?.find((res) => res.key == "tax_and_charges")
                    .childCalculationList.map((item) => item.label)
                    .join(","),
                  taxChargesAmount: response?.data?.calculations
                    ?.find((res) => res.key == "tax_and_charges")
                    .childCalculationList.map((item) => item.amount)
                    .join(","),
                  discount: response.data.calculations.find(
                    (res) => res.key == "discount"
                  )?.amount,
                  subTotal: response.data.calculations.find(
                    (res) => res.key == "sub_total"
                  )?.amount,
                  itemTotal:
                    parseFloat(
                      response.data.calculations.find(
                        (res) => res.key == "sub_total"
                      )?.amount || 0
                    ) -
                    parseFloat(
                      response?.data?.calculations?.find(
                        (res) => res.key == "discount"
                      )?.amount || 0
                    ) +
                    parseFloat(
                      response?.data?.calculations?.find(
                        (res) => res.key == "tax_and_charges"
                      )?.amount || 0
                    ),
                  coupon: payload.couponCode,
                  deliveryCharge: response?.data?.calculations?.find(
                    (res) => res.key == "tax_and_charges"
                  )?.amount,
                  paymentMethodSaved: "No",
                });
              } else {
                EVENT_OFFER_SCREEN({
                  eventAction: "offer applied",
                  sectionName: payload.source,
                  category: "offer application",
                  subcategory: "offer application success",
                  cartId: LocalStorageFunc.cartId(),
                  failureReason: errMsg,
                  couponDetail: payload.detail,
                  paymentMethod: "",
                  taxChargesCategory: response?.data?.calculations
                    ?.find((res) => res.key == "tax_and_charges")
                    .childCalculationList.map((item) => item.label)
                    .join(","),
                  taxChargesAmount: response?.data?.calculations
                    ?.find((res) => res.key == "tax_and_charges")
                    .childCalculationList.map((item) => item.amount)
                    .join(","),
                  discount: response.data.calculations.find(
                    (res) => res.key == "discount"
                  )?.amount,
                  subTotal: response.data.calculations.find(
                    (res) => res.key == "sub_total"
                  )?.amount,
                  itemTotal:
                    parseFloat(
                      response.data.calculations.find(
                        (res) => res.key == "sub_total"
                      )?.amount || 0
                    ) -
                    parseFloat(
                      response?.data?.calculations?.find(
                        (res) => res.key == "discount"
                      )?.amount || 0
                    ) +
                    parseFloat(
                      response?.data?.calculations?.find(
                        (res) => res.key == "tax_and_charges"
                      )?.amount || 0
                    ),
                  coupon: payload.couponCode,
                  deliveryCharge: response?.data?.calculations?.find(
                    (res) => res.key == "tax_and_charges"
                  )?.amount,
                  paymentMethodSaved: "No",
                });
              }
              LocalStorageFunc.setOfferAppliedModal(true);
              Utility.sendToCartScreen();
            }
            !errMsg &&
              dispatch(
                "Cart/createCartItemsApi",
                { code: payload.couponCode },
                { root: true }
              );
            if (!errMsg) LocalStorageFunc.updateCouponCode(payload.couponCode);
          } else {
            errMsg =
              response.data.errorMessages[0].message ||
              response.data.discountAllocations[0].errors[0].displayMessage;
            errMsg && commit("updateOfferFailedMsg", errMsg || "");

            errMsg && commit("updateShowOfferFailedMsg", true);
            setTimeout(() => {
              commit("updateShowOfferFailedMsg", false);
            }, 5000);
            if (payload.source && payload.source == "MANUAL") {
              EVENT_CLICK_APPLYMANUALCOUPONFAILURE({
                category: `manual offer applied - ${payload.couponCode}`,
                discountAmount: rootState.Offers.discount,
                cartValue: rootGetters[keyMapsGetter.CART_TOTAL],
              });
              EVENT_OFFER_SCREEN({
                eventAction: "coupon applied",
                sectionName: "manual input",
                category: "coupon application",
                subcategory: "coupon application failure",
                cartId: LocalStorageFunc.cartId(),
                failureReason: errMsg,
                couponDetail: payload.detail,
                paymentMethod: "",
                taxChargesCategory: response?.data?.calculations
                  ?.find((res) => res.key == "tax_and_charges")
                  ?.childCalculationList?.map((item) => item?.label)
                  .join(","),
                taxChargesAmount: response?.data?.calculations
                  ?.find((res) => res.key == "tax_and_charges")
                  ?.childCalculationList?.map((item) => item?.amount)
                  .join(","),
                discount: response.data.calculations.find(
                  (res) => res.key == "discount"
                )?.amount,
                subTotal: response.data.calculations.find(
                  (res) => res.key == "sub_total"
                )?.amount,
                itemTotal:
                  parseFloat(
                    response.data.calculations.find(
                      (res) => res.key == "sub_total"
                    )?.amount || 0
                  ) -
                  parseFloat(
                    response?.data?.calculations?.find(
                      (res) => res.key == "discount"
                    )?.amount || 0
                  ) +
                  parseFloat(
                    response?.data?.calculations?.find(
                      (res) => res.key == "tax_and_charges"
                    )?.amount || 0
                  ),
                coupon: payload.couponCode,
                deliveryCharge: response?.data?.calculations?.find(
                  (res) => res.key == "tax_and_charges"
                )?.amount,
                paymentMethodSaved: "No",
              });
            } else {
              EVENT_CLICK_APPLYOFFERFAILURE({
                positionWithinSection: rootState.Offers.selectedOfferIndex + 1,
                category: `Offer Failed - ${payload.couponCode}`,
                subCategory: response.data.explicitPromo?.errors[0]?.displayMsg,
                cartValue: rootGetters[keyMapsGetter.CART_TOTAL],
                couponCode: payload.couponCode,
                couponIndex: rootState.Offers.selectedOfferIndex + 1,
              });
              EVENT_OFFER_SCREEN({
                eventAction: "offer applied",
                sectionName: payload.source,
                catergory: "offer application",
                subcatergory: "offer application failure",
                cartId: LocalStorageFunc.cartId(),
                failureReason: errMsg,
                couponDetail: payload.detail,
                paymentMethod: "",
                taxChargesCategory: response?.data?.calculations
                  ?.find((res) => res.key == "tax_and_charges")
                  ?.childCalculationList?.map((item) => item?.label)
                  ?.join(","),
                taxChargesAmount: response?.data?.calculations
                  ?.find((res) => res.key == "tax_and_charges")
                  ?.childCalculationList?.map((item) => item?.amount)
                  ?.join(","),
                discount: response?.data?.calculations?.find(
                  (res) => res?.key == "discount"
                )?.amount,
                subTotal: response?.data?.calculations?.find(
                  (res) => res?.key == "sub_total"
                )?.amount,
                itemTotal:
                  parseFloat(
                    response?.data?.calculations?.find(
                      (res) => res?.key == "sub_total"
                    )?.amount || 0
                  ) -
                  parseFloat(
                    response?.data?.calculations?.find(
                      (res) => res?.key == "discount"
                    )?.amount || 0
                  ) +
                  parseFloat(
                    response?.data?.calculations?.find(
                      (res) => res?.key == "tax_and_charges"
                    ).amount || 0
                  ),
                coupon: payload.couponCode,
                deliveryCharge: response?.data?.calculations?.find(
                  (res) => res?.key == "tax_and_charges"
                ).amount,
                paymentMethodSaved: "No",
              });
            }
            errMsg =
              response.data.errorMessages[0].message ||
              response.data.discountAllocations[0].errors[0].displayMessage;
            errMsg && commit("updateOfferFailedMsg", errMsg || "");

            errMsg && commit("updateShowOfferFailedMsg", true);
            setTimeout(() => {
              commit("updateShowOfferFailedMsg", false);
            }, 5000);

            if (!errMsg) {
              response.data.errors[0].displayMsg &&
                commit(
                  "updateOfferFailedMsg",
                  response.data.errors[0].displayMsg || ""
                );

              response.data.errors[0].displayMsg &&
                commit("updateShowOfferFailedMsg", true);
              setTimeout(() => {
                commit("updateShowOfferFailedMsg", false);
              }, 5000);
            }
            commit("updateFailedOfferPromo", payload.couponCode);
            commit("updateDiscount", "");
            if (payload.source && payload.source == "MANUAL") {
              commit("updateManualOffer", payload.couponCode);
            }
          }
        })
        .catch(function (error) {
          if (payload.source && payload.source == "MANUAL") {
            EVENT_CLICK_APPLYMANUALCOUPONFAILURE({
              category: `manual offer applied - ${payload.couponCode}`,
              discountAmount: rootState.Offers.discount,
              cartValue: rootGetters[keyMapsGetter.CART_TOTAL],
            });
          } else {
            EVENT_CLICK_APPLYOFFERFAILURE({
              positionWithinSection: rootState.Offers.selectedOfferIndex + 1,
              category: `Offer Failed - ${payload.couponCode}`,
              subCategory: error,
              cartValue: rootGetters[keyMapsGetter.CART_TOTAL],
              couponCode: payload.couponCode,
              couponIndex: rootState.Offers.selectedOfferIndex + 1,
            });
          }

          LocalStorageFunc.updateCouponCode(payload.couponCode); //todo : remove it after api integration
          commit("updateOfferApplyResponse", {});
          commit(
            "updateOfferFailedMsg",
            "Something went wrong. Please reapply the coupon"
          );
          commit("updateShowOfferFailedMsg", true);
          setTimeout(() => {
            commit("updateShowOfferFailedMsg", false);
          }, 3000);
          // commit("updateDiscount", 0);
        });
    },
    removeOfferApi({ commit, dispatch, rootState }, payload) {
      commit("updateOfferApplyResponse", {});
      ApiCalls.REMOVE_WELCOME_OFFER_API({
        headers: { ...Headers() },
        payload: {
          promos: [{ code: payload.couponCode }],
        },
      })
        .then(function (response) {
          if (
            response.data.status == "SUCCESS" ||
            response.data.status == "PARTIAL"
          ) {
            commit("updateAppliedOfferPromo", "");
            LocalStorageFunc.updateCouponCode("");
            commit("updateManualOffer", "");
            commit("updateOfferFailedMsg", "");
            commit("Cart/updateAmountSavedMsg", "", { root: true });
            dispatch("Cart/createCartItemsApi", {}, { root: true });
            if (payload?.sendToOffersScreen) {
              Utility.sendToOffersScreen();
            }
          } else {
            commit("updateManualOffer", "");
          }
        })
        .catch(function (error) {
          LocalStorageFunc.updateCouponCode(""); //todo : remove it after api integration
        });
    },
    offerTncApi({ commit }, payload) {
      ApiCalls.OFFER_TNC_API({
        headers: Headers(),
        payload: {
          campaignId: payload.campaignId,
        },
      })
        .then(function (response) {
          if (response?.data?.tnc) {
            commit("updateSelectedOfferTnc", response.data.tnc);
          } else {
            commit("updateSelectedOfferTnc", []);
          }
        })
        .catch(function (error) {
          commit("updateSelectedOfferTnc", []);
        });
    },
  },
};
